import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=e8877b76&"
import script from "./Overview.vue?vue&type=script&lang=js&"
export * from "./Overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8877b76')) {
      api.createRecord('e8877b76', component.options)
    } else {
      api.reload('e8877b76', component.options)
    }
    module.hot.accept("./Overview.vue?vue&type=template&id=e8877b76&", function () {
      api.rerender('e8877b76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Views/Overview.vue"
export default component.exports